<template>
	<div>
		<el-row :gutter="40">
			<el-col :span="12">
				<el-form :model="form" :rules="rules" ref="form">
		          	<el-select v-model="userID" allow-create filterable placeholder="Коллекция" style="width: 100%;">
					    <el-option v-for="item in users" :value="item.value" :label="item.label"></el-option>
				  	</el-select>
		          	<el-form-item label="Модификация" prop="mod" v-if="collection">
		            	<el-select v-model="form.mod" style="width: 100%;">
					    	<el-option v-for="item in filters" :value="item.value" :label="item.label"></el-option>
					  	</el-select>
		          	</el-form-item>
		          	<el-form-item v-if="collection && form.mod != ''" label="Тип экспорта" prop="type">
						<div style="clear: left;"><el-switch v-model="form.type" active-text="Полный" inactive-text="Сокращённый" active-value="full" inactive-value="compact" active-color="#13ce66" inactive-color="#409EFF"></el-switch></div>
					</el-form-item>		
		          	<el-form-item v-if="uid == 'LNgKWoXVvpS9bKKEUKzNJ4HX3sk1'" label="Область экспорта" prop="type">
						<div style="clear: left;"><el-switch v-model="form.area" active-text="Коллекция" inactive-text="База Данных" active-value="collection" inactive-value="database" active-color="#13ce66" inactive-color="#409EFF"></el-switch></div>
					</el-form-item>	
		          	<el-form-item v-if="collection && form.mod != ''" label="JSON" prop="file">
		            	<el-input v-model="file" :autosize="{minRows: 2, maxRows: 10}" type="textarea"></el-input>
		          	</el-form-item>
		        </el-form>
		   	</el-col>
		</el-row>
		<hr>
		<el-row :gutter="40">
			<el-col>
				<p>На этой странице можно экспортировать коллекции предметов в формате JSON. Для этого выберите коллекцию из выпадающего списка или укажите ID пользователя, коллекцию которого вы хотите экспортировать, затем выберите интересующую Вас модификацию. После выбора модификации появится переключатель с типом экспорта, оставьте его в положении "Полный" и скопируйте содержимое в файл с форматом JSON. При помощи экспорта периодически можно будет делать бэкапы Вашей коллекции предметов. Бэкапы могут потребоваться в случае надобности восстановления коллекции. Так же при помощи экспорта Вы можете делиться своими наработками с другими пользователями.</p>
			</el-col>
		</el-row>
	</div>		
</template>

<script>
import {db, storage} from '../firebase.js';
import {modsList} from '../functions.js';
export default {
	data() {
      	return {
        	form:{
	          	mod: '',
	          	price: true,
	          	type: 'full',
	          	area: 'collection',
        	},
          	rules: {
            	mod: [
	              	{required: true, message: 'Это поле обязательно для заполнения', trigger: 'blur',},
            	],
          	},
          	collection: null,
          	userID: null,
      	}
	},
	watch: {
		userID(){
			var self = this;
			self.getUserCollection();
			self.form.mod = '';
		},
	},
	computed: {
		users(){
			var self = this;
			var users = [];
			var ID = self.$store.state.user.uid || null;
			if (ID) {
				users.push({label: 'Ваша коллекция', value: ID});
			};
			users.push({label: 'PowerCraft', value: 'JKIv2FDqKJhbdMWixSD3nvP4tz33'});
			return users;
		},
		selfID(){
			var self = this;
			var ID = self.$store.state.user.uid || null;
			return ID;
		},
		filters(){
			var self = this;
			var filters = [{label: 'Все модификации', text: 'Все модификации', value: 'all'}];			
  			if (self.form.area == 'database') {
  				filters = filters.concat(modsList);
  			} else {
				for (var prop in self.collection) {
					if (self.collection[prop].length > 0){
	  					filters.push(modsList.find(el=>{return el.value == prop}));
					};
	  			};  		
  			};
  			return filters;
		},
		uid() {
			var self = this;
			var user = self.$store.state.user;
			return (user) ? user.uid : null;
		},
		file() {
			var self = this;
			var json = [];
			var collection = [];
			var collections = {};
			if (self.form.area == 'database') {
				self.form.type = 'compact';
				collections = self.$store.state.itemCollection;
			} else {
				collections = self.collection;
			};
			if (self.form.mod == 'all') {
				for (var prop in collections) {
					collection = collection.concat(collections[prop]);
				};
			} else {
				collection = collections[self.form.mod];
			};
			if (collection) {
				collection.forEach(function(el){
					if (self.form.type == 'full') {
						json.push({
				    		count: el.count,
							key: el.key,
							pattern: el.pattern,
							customPrice: el.customPrice,
							recipePrice: el.recipePrice,
							priceType: el.priceType,
							ingredients: el.ingredients,
							price: el.price,
							item: el.item,
							mod: el.mod,
					    });	
					} else {
						if (self.form.area == 'database') {
							delete el.displayName;
							delete el.name;
							delete el.params;
							json.push(el);
						} else {
							var itemProp = el.item.split(':');
							var itemName = itemProp[0] + ':' + itemProp[1];
							var itemMeta = itemProp[2];
							var key = el.key;
							for (var prop in key) {
								delete key[prop].price;
							};
							json.push({
								"Item Name": itemName,
							    "Item ID": el.id,
							    "Item meta": itemMeta,
							    "Display Name": el.displayName,
							    "recipe": {
							    	"pattern": el.pattern,
							    	"key": key,
							    	"count": el.count,
							    },
							    "mod": el.mod,
							});
						};
					};
				});
			};	
			return JSON.stringify(json, null, 2);
		},
	},
	mounted(){
  	},
	methods: {
		getUserCollection(){
			var self = this;
			var collection = null;
			var selfID = self.$store.state.user.uid || null;
			var itemCollection = self.$store.state.itemCollection;
			if (self.userID == selfID) {
				self.collection = self.$store.state.userCollection;
			} else {
				db.collectionGroup('recipes').where("author", "==", self.userID).get().then(function(querySnapshot) {
					if (querySnapshot.size > 0) {
						collection = {};
				        querySnapshot.forEach(function(doc) {
				          	var data = doc.data();
				          	var mod = doc.ref.path.split('/')[1];
				          	collection[mod] = [];
				          	for (var prop in data) {
				            	if (prop != 'author' && prop != 'rating' && prop != 'newRecipes') {  
				              		var el = data[prop];
				              		var price = el.priceType == 'customPrice' ? el.customPrice : el.recipePrice;
				              		var meta = undefined;
				              		if (itemCollection[mod]) {
				                		meta = itemCollection[mod].find(function(subEl){return subEl.name == prop;});
				              		} else {
					                	var key = el.key;
					                	for (var subProp in key) {
					                  		var mod = key[subProp].mod;
					                	};
				              		};
					              	if (meta != undefined) {
					                	collection[mod].push({
					                  		displayName: meta.displayName,
					                  		item: prop,
					                  		price: price,
					                  		image: meta.image,
					                  		ingredients: el.ingredients,
					                  		id: meta.itemID,
					                  		pattern: el.pattern,
					                  		key: el.key,
					                  		count: el.count,
					                  		mod: meta.mod,
					                  		customPrice: el.customPrice,
					                  		recipePrice: el.recipePrice,
					                  		priceType: el.priceType,
					                	}); 
					              	};
				            	};  
				          	};
				        });
			        	self.collection = collection;
					} else {
						self.collection = null;
					};
			    });
			};	
		},    
	},
};
</script>